/* @flow */
import {
    INJECT_ERROR,
    ACKNOWLEDGE_ERROR,
    FETCH_API_ERROR
} from 'common/constants/actionTypes';
import { ApiError, AbortError } from 'common/modules/api';
import { type Dispatch } from 'redux';

type ToggleAPIErrorAction = {
    type: typeof FETCH_API_ERROR,
    payload: boolean
};
export const toggleAPIError = (status: boolean): ToggleAPIErrorAction => {
    return {
        type: FETCH_API_ERROR,
        payload: status
    };
};

type InjectErrorAction = {
    type: typeof INJECT_ERROR,
    response: Error
};
export const injectError = (error: Error): InjectErrorAction => {
    return {
        type: INJECT_ERROR,
        response: error
    };
};

type AcknowledgeErrorAction = {
    type: typeof ACKNOWLEDGE_ERROR,
    response: Error
};
export const acknowledgeError = (error: Error): AcknowledgeErrorAction => {
    return {
        type: ACKNOWLEDGE_ERROR,
        response: error
    };
};
export const handleGenericError = (
    dispatch: Dispatch<$FixMe>,
    error: Error
) => {
    if (error instanceof AbortError) {
        return;
    }
    if (error instanceof ApiError) {
        dispatch(injectError(error));
    } else {
        throw error;
    }
};
export type ErrorAction =
    | ToggleAPIErrorAction
    | InjectErrorAction
    | AcknowledgeErrorAction;
